export default __webpack_public_path__ + "static/media/AUUM1.3b26f56c.png";